import React, { type Dispatch, type SetStateAction } from "react";
import { SupTransactionInput } from "@repo/ui-widgets";

import { useAmountState } from "@/components/Web3/Common/AmountState";
import { formatCurrencyCompact } from "@/utils";
import config from "@/../config/dapp.config";
import type { SupWeb3Balance, SupWeb3TxSingleVault } from "@/types";

interface Web3DepositAmountProps {
  singleVault: SupWeb3TxSingleVault;
  selectedBalance: SupWeb3Balance;
  vaultList: SupWeb3TxSingleVault[];
  setVaultList: Dispatch<SetStateAction<SupWeb3TxSingleVault[]>>;
  className?: string;
}

export default function Web3DepositAmount({ selectedBalance, singleVault, className }: Web3DepositAmountProps) {
  const { price: tokenPrice } = selectedBalance;
  const { updateVaultAmount, getVaultAmount } = useAmountState();

  function handleAmountChange(value = "") {
    updateVaultAmount?.(singleVault.id, value);
  }

  const amount = getVaultAmount?.(singleVault.id);

  return (
    <SupTransactionInput
      fluid
      value={amount}
      className="mb-2"
      variant="input"
      label="Depositing"
      onChange={handleAmountChange}
      input={{
        className,
        placeholder: "0",
        suffix: selectedBalance.symbol,
        hintFormatter: value =>
          value && !isNaN(parseFloat(value))
            ? formatCurrencyCompact(parseFloat(value) * tokenPrice, config.decimalsRoundingLimit, config.decimalsRoundingLimit, "currency", "standard")
            : "",
      }}
    />
  );
}
